
import { Client } from "../../types";
import { Info } from "lucide-react";
import { FieldIndicator } from "./FieldIndicator";

interface CompanySummarySectionProps {
  client: Client;
  fieldsWithNewData: Set<keyof Client>;
}

export const CompanySummarySection: React.FC<CompanySummarySectionProps> = ({ client, fieldsWithNewData }) => {
  const hasNewDescription = fieldsWithNewData.has('description');
  
  if (!client.description && !hasNewDescription) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-slate-200 border-b pb-2 flex items-center">
        <Info className="w-5 h-5 mr-2 text-invenio-primary" />
        Company Summary
        <FieldIndicator fieldName="description" fieldsWithNewData={fieldsWithNewData} />
      </h3>
      <p className="text-sm whitespace-pre-wrap">{client.description || "Not specified"}</p>
    </div>
  );
};
